const constants = {
  themeColor: "#f04a00",
};

export default constants;
